module.exports = __webpack_public_path__ + "images/mango_smallf2724e63100811a526572fd22761bf52.png";